/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Usettings_Memory_DescriptionInputs */



/**
* | output |
* | --- |
* | "Uno notes a few durable details about how you work and uses them in its answers. Turning this off stops new notes and stops Uno using the existing ones." |
*
* @param {Uno_Usettings_Memory_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_usettings_memory_description = /** @type {((inputs?: Uno_Usettings_Memory_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Usettings_Memory_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Uno notiert sich einige dauerhafte Details zu deiner Arbeitsweise und nutzt sie in seinen Antworten. Ausgeschaltet entstehen keine neuen Notizen und die vorhandenen werden nicht mehr verwendet.")
	return /** @type {LocalizedString} */ ("Uno notes a few durable details about how you work and uses them in its answers. Turning this off stops new notes and stops Uno using the existing ones.")
});